import PropTypes from 'prop-types';
import React from 'react';
import { Component as ComponentType } from './types';
import { ComponentStatuses as ComponentStatusesType } from './types';

const StatusDropdown = require('components/manage/pages/components/status_dropdown');
const StatusOverride = require('components/manage/pages/components/status_override');

class ComponentStatusSelector extends React.Component {

  static propTypes = {
    component: ComponentType.isRequired,
    componentStatuses: ComponentStatusesType.isRequired,
    informParent: PropTypes.func,
    isChild: PropTypes.bool,
    isGroupParent: PropTypes.bool,
    pageParam: PropTypes.string.isRequired,
    shouldAutoUpdate: PropTypes.bool.isRequired,
    toggleOverridden: PropTypes.func,
  };

  static defaultProps = {
    informParent: new Function(),
    isChild: false,
    isGroupParent: false,
    toggleOverridden: new Function(),
  };

  constructor (props) {
    super(props);
    this.canOverride = (this.props.isGroupParent || this.props.component.is_third_party);
    this.state = {
      dropdownEnabled: this._initialDropdownState(),
      currentStatus: this.props.component.status,
    };
  }

  componentWillReceiveProps (newProps) {
    this.setState({ currentStatus: newProps.currentStatus });
  }

  _initialDropdownState () {
    // All non-group components and overridden components are active.
    return !this.canOverride || this.props.component.is_overridden;
  }

  _toggleActiveDropdown () {
    // Toggle overridden if we're working with a group
    if (this.props.isGroupParent) {
      this.props.toggleOverridden();
      this.props.informParent();
    }

    // Tell the parent if we're working with a child
    if (this.props.isChild) {
      this.props.informParent(this.props.component.id, this.props.component.name);
    }

    if (this.state.dropdownEnabled) {
      // 3PCs use their provided based_on_status
      if (this.props.component.is_third_party) {
        const newStatus = this.props.component.based_on_status;
        this.setState({ currentStatus: newStatus });
      }

      // And let the server know we're using derived/based on status
      if (this.props.shouldAutoUpdate) {
        this._updateComponent(null);
      }
    }

    this.setState({ dropdownEnabled: !this.state.dropdownEnabled });
  }

  _updateComponent (newStatus, newName = 'its derived status') {
    const successMessage = `Successfully updated ${this.props.component.name} to ${newName}.`;

    $.ajax({
      type: 'PUT',
      url: Routes.page_component_path(this.props.pageParam, this.props.component.id, { format: 'json' }),
      data: { component: { status: newStatus } },
      success (data, textStatus, xhr) {
        HRB.utils.notify(successMessage);
      },
      error (xhr, textStatus) {
        HRB.utils.basicFailAndReload(xhr);
      },
    });
  }

  _displayDropdown () {
    return (<StatusDropdown
      isEnabled={this.state.dropdownEnabled}
      component={this.props.component}
      currentStatus={this.state.currentStatus}
      componentStatuses={this.props.componentStatuses}
      shouldAutoUpdate={this.props.shouldAutoUpdate}
      updateComponent={this._updateComponent.bind(this)}
      informParent={this.props.informParent}
      isChild={this.props.isChild}
      isGroup={this.props.isGroupParent} />);
  }

  _displayOverride () {
    if (this.canOverride) {
      return (<StatusOverride
        isActive={this.state.dropdownEnabled}
        componentParam={this.props.component.id}
        onClick={this._toggleActiveDropdown.bind(this)} />);
    }
  }

  render () {
    return (
      <div className="component-status-container">
        { this._displayOverride() }
        { this._displayDropdown() }
      </div>
    );
  }
}

module.exports = ComponentStatusSelector;



// WEBPACK FOOTER //
// ./app/assets/javascripts/components/manage/pages/components/component_status_selector.jsx